export const UpdateCredentialsTooltip = () => (
  <>
    Regenerate user AWS keys. NOTE: this might invalidate other AWS IAM sessions
    opened for current user, such as opened S3 Explorer in another browser.
  </>
);
